import React from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import Constants from '../../../definitions/constants';

import GlassPopup from '../common/interface/glassPopup';
import ToggleSection from '../common/interface/toggleSection';
import TextBox from '../common/inputs/textBox';
import CheckBox from '../common/inputs/checkBox';
import Select from '../common/inputs/select';
import FreeTextList from '../common/inputs/freeTextList';
import Label from '../common/inputs/label';
import ErrorFeedback from '../common/feedback/errorFeedback';
import TagsSelector from '../common/inputs/tagsSelector';

const FormPopup = props => {
  const {
    handleShowPopup,
    handleOnChangeForm,
    handleButton,
    loadingButton,
    fullLoading,
    statusButton,
    dimensionInstancesStatus,
    formData,
    errors,
    entityNameSingular,
    popupState,
    handleShowImportDimensionInstancesFormPopup,
    handleEntityQueryDataPopup,
    tagsOptions, // Array: Array of tags with the existing tags, to be used in the TagsSelector component
  } = props;
  return (
    <GlassPopup
      className="form_popup"
      title={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      buttonText={(<FormattedMessage 
         id={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.id") ? "common.entity.editEntity" : "common.entity.createEntity"}
         values={{entityNameSingular: entityNameSingular}}
       />)}
      type={Constants.interface.popup.types.LATERAL}
      {...props}
    >
      <ErrorFeedback
        status={statusButton}
        fieldErrors={errors}
        localesFieldsPath="dimensionAdmin.fields"
        optionalStatusErrors={{
          "406": intl.formatMessage({id: "common.entity.saveEntityCantDeactivateError"},
             {entityNameSingular: FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "dimensionAdmin.entityNameSingularWithArticle"})), 
              detail: (errors.message ? intl.formatMessage({id: "common.errors.detailLabel"}) + errors.message : "")
             })
        }}
      />
      {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.id") && (
        <i 
          className="fas fa-search entity_use_query_icon" 
          data-entityid={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.id")} 
          onClick={handleEntityQueryDataPopup}
        />
      )}
      <TextBox 
        styleType={Constants.interface.inputs.styleType.OUTLINED}
        type={Constants.interface.inputs.type.TEXT}
        id="name"
        data-path="dimension.name"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.name")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="dimensionAdmin.fields.name"/>}
        className={("name" in errors) ? "has_error" : null}
      />
      <Select 
        id="data_type"
        data-path="dimension.data_type"
        value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.data_type")}
        onChange={handleOnChangeForm}
        labelLocale={<FormattedMessage id="dimensionAdmin.fields.data_type"/>}
        options={InterfaceTooling.getSelectArray("selectKeys.dimension.dataType","dimensionAdmin.fields.selectValues.data_type")}
        disabled={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.id") ? true : false}
        className={("data_type" in errors) ? "has_error" : null}
      />
      <div className="row_fields">
        <CheckBox 
          id="allow_empty_dimension_instance_value"
          data-path="dimension.allow_empty_dimension_instance_value"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.allow_empty_dimension_instance_value")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="dimensionAdmin.fields.allow_empty_dimension_instance_value"/>}
          className={("allow_empty_dimension_instance_value" in errors) ? "has_error" : null}
        />
      </div>
      <label className="form_info dimension_admin_allow_empty_help">
        <FormattedMessage 
          id={"dimensionAdmin.allowEmptyDimensionInstanceValueInfo"}
        />
      </label>
      {JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.id") && (
        <CheckBox 
          id="active"
          data-path="dimension.active"
          value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.active")}
          onChange={handleOnChangeForm}
          labelLocale={<FormattedMessage id="common.entity.fields.active"/>}
        />
      )}
      {(dimensionInstancesStatus==200 && JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.id")) && (
        <FreeTextList        
          values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.dimension_instances")}
          onChange={handleOnChangeForm}
          data-path="dimension.dimension_instances"
          addTextLocale={intl.formatMessage({ id: "dimensionAdmin.createDimensionValue"}) 
            + " (" + intl.formatMessage({ id: "metricAdmin.fields.selectValues.data_type.helpers." + JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.data_type")}) + ")"}
          searchTextLocale={<FormattedMessage id="dimensionAdmin.findDimensionValues"/>}
          labelLocale={<FormattedMessage id="dimensionAdmin.fields.domain_input_source"/>}
          noEmptyTextLocale={intl.formatMessage({id: "dimensionAdmin.emptyInstanceError"})}
          noRepeatTextLocale={intl.formatMessage({id: "dimensionAdmin.repeatInstanceError"})}
          valueAccesor={"value"}
          dataType={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.data_type")}
          additionalControls={(
            <Select 
              id="domain_input_source"
              data-path="dimension.domain_input_source"
              value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.domain_input_source")}
              onChange={handleOnChangeForm}
              labelLocale={<FormattedMessage id="dimensionAdmin.fields.domain_input_source"/>}
              options={InterfaceTooling.getSelectArray("selectKeys.dimension.domain_input_source","dimensionAdmin.fields.selectValues.domain_input_source", false)}
            />          
          )}
          hideList={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.domain_input_source") == Constants.selectKeys.dimension.domain_input_source.DEF_USER ? false : true}
          handleExcelButton={handleShowImportDimensionInstancesFormPopup}
          showQuantity={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.domain_input_source") == Constants.selectKeys.dimension.domain_input_source.DEF_USER ? true : false}
          formatter={FormatTooling.getMetricDatasFormatTypeFunction(JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.data_type"))}
          className={("value" in errors) ? "has_error" : null}
        />
      )}
      <ToggleSection title={<FormattedMessage id="dimensionAdmin.fields.reportsConfigTitle"/>}>
        <div>
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="report_label"
            data-path="dimension.report_label"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.report_label")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="dimensionAdmin.fields.report_label"/>}
            className={("report_label" in errors) ? "has_error" : null}
          />
          <TextBox 
            styleType={Constants.interface.inputs.styleType.OUTLINED}
            type={Constants.interface.inputs.type.TEXT}
            id="format"
            data-path="dimension.format"
            value={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.format")}
            onChange={handleOnChangeForm}
            labelLocale={<FormattedMessage id="dimensionAdmin.fields.format"/>}
            className={("format" in errors) ? "has_error" : null}
          />
        </div>
      </ToggleSection>
      {!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.id") && (
        <label className="form_info">
          <FormattedMessage 
            id={"dimensionAdmin.preCreateInfo"}
          />
        </label>
      )}
      {!JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.id") && (
        <label className="form_info">
          <FormattedMessage 
            id={"dimensionAdmin.dimensionInstancesPreCreateInfo"}
          />
        </label>
      )}
      <TagsSelector
        id={"tags"}
        values={JavascriptUtilsTooling.getObjectStringPathKeyValue(formData,"dimension.tags")}
        onClickOption={handleOnChangeForm}
        options={tagsOptions}
        data-path="dimension.tags"
      />
    </GlassPopup>
  );
};

export default FormPopup;



// WEBPACK FOOTER //
// ./source/client/components/dimensionAdmin/formPopup.jsx